function ViewDamageDetailsController() {
    this.constructor.apply(this, arguments);
}

ViewDamageDetailsController.$inject = ['$mdPanel', 'close', '$translationService', '$q', 'damage', 'AttackmentService', 'UtilityService', 'VehicleBookingService'];
ViewDamageDetailsController.prototype = {
    /**
     *
     * @param $mdPanel {$mdPanel}
     * @param close {Function}
     * @param $translationService {$translationService}
     * @param $q {$q}
     * @param damage {IVehicleDamage}
     * @param AttackmentService {AttackmentService}
     * @param UtilityService {UtilityService}
     * @param VehicleBookingService {VehicleBookingService}
     */
    constructor($mdPanel, close, $translationService, $q, damage, AttackmentService, UtilityService, VehicleBookingService) {
        this.$mdPanel = $mdPanel;
        this.close = close;
        this.$translationService = $translationService;
        this.$q = $q;
        this.attackmentService = AttackmentService;
        this.utilityService = UtilityService;
        this.vehicleBookingService = VehicleBookingService;


        /** @type {IVehicleDamage} */
        this.damage = damage;

        /** @type {IVehicleDamageLocationItem} */
        this.location = null;




        if (damage && damage.Location) {
            this.location = this.vehicleBookingService.getLocations().find((location) => {
                return location.Name === damage.Location;
            })
        }

        // Restore photo
        if(this.damage.DocumentId){
            this.imageSrc = this.attackmentService.buildFullImageUrl(this.damage.DocumentId, this.damage.DocumentName);
        }

    },


    ready() {

    },

    goBack(data) {
        this.close(data);
    },



    showImageViewer($event){
        let attachment = this.vehicleBookingService.getAttachmentFromDamage(this.damage);
        attachment.Name = this.damage.DocumentName|| this.damage.DocumentId;
        let attachments = [attachment];
        this.utilityService.showImageViewer(attachment,  attachments, $event);
    }

}
angular.module('internal.vehiclebookings').controller('ViewDamageDetailsController', ViewDamageDetailsController);